export enum EWeightUnit {
  GRAM = 'g',
  KILOGRAM = 'kg',
  LITER = 'l',
  ML = 'ml'
}